import React, { useEffect, useState } from "react";
import "./FooterNav.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faCalendar, faUser, faShareSquare } from '@fortawesome/free-regular-svg-icons';
import { logout } from "../config/firebase";
import { Link, useNavigate } from "react-router-dom";
import { isAppMode } from "../utils/appMode";

function FooterNav() {
  const [appMode, setAppMode] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setAppMode(isAppMode());
  }, []);

  return (
    <>
      {!appMode &&
        <div className="app-footer-navigation">
          <Link className="app-footer-navigation-button btn btn-secondary p-1 pt-2 border-0 rounded-0" to="/page/teetimes">{<FontAwesomeIcon className="app-footer-navigation-button-icon fa-thin" icon={faClock} />}<small>Tee Times</small></Link>
          <Link className="app-footer-navigation-button btn btn-secondary p-1 pt-2 border-0 rounded-0" to="/page/reservations">{<FontAwesomeIcon className="app-footer-navigation-button-icon" icon={faCalendar} />}<small>Reservations</small></Link>
          <Link className="app-footer-navigation-button btn btn-secondary p-1 pt-2 border-0 rounded-0" to="/page/profile">{<FontAwesomeIcon className="app-footer-navigation-button-icon" icon={faUser} />}<small>Account</small></Link>
          <button
            type="button"
            className="app-footer-navigation-button btn btn-secondary p-1 pt-2 border-0 rounded-0"
            onClick={async () => {
              await logout();
              const groupId = localStorage.getItem('group');
              navigate(groupId ? `/group/${encodeURIComponent(groupId)}` : '/', { replace: true });
            }}
          >{<FontAwesomeIcon className="app-footer-navigation-button-icon" icon={faShareSquare} />}<small>Logout</small></button>
        </div>
      }
    </>
  );
}
export default FooterNav;
